<template>
  <article>
    <h1>Privacy Policy</h1>

    <section>
      <h2>OUR PRIVACY PROMISE</h2>

      <p>
        Our Privacy and Cookie Notice below sets out in detail how we process
        your personal data, and we encourage you to read it in full. However, we
        also understand that people have busy lives and won't always find the
        time to read everything online immediately, and so wanted to help you by
        providing a brief overview of how and why we process your personal data.
      </p>

      <p>
        We mainly only collect and process your personal data for two reasons:
        to provide you with services and to comply with legal and regulatory
        obligations.
      </p>
    </section>

    <section>
      <h2>I. INTRODUCTION. REGIONAL PATTERNS (CALIFORNIA)</h2>

      <p>
        Grotem Limited LLC (“we,” “us” or “our”) takes your privacy seriously.
        This Privacy policy ("Privacy policy") explains our data protection
        policy and describes the types of information we may process when you
        use “Lily - Plant identification” web site (“Service”)
      </p>

      <p>
        When we refer to personal data (or personal information) we mean any
        information of any kind relating to a natural person who can be
        identified, directly or indirectly, in particular by reference to such
        data.
      </p>

      <p>
        It is a natural person who can be identified directly or indirectly, in
        particular by reference to an identification number or to one or more
        factors specific to his or her physical, physiological, mental,
        economic, cultural or social status.
      </p>

      <p>
        Our Privacy policy applies to all users, and others who access the
        Service (“Users”).
      </p>

      <p>
        For the purposes of the GDPR, we are the data controller, unless
        otherwise stated.
      </p>

      <p>
        PLEASE READ THE FOLLOWING PRIVACY POLICY, FOR INFORMATION REGARDING THE
        WAYS YOUR PERSONAL INFORMATION MAY BE PROCESSED, CAREFULLY. WHEN YOU USE
        THE APP YOU ACKNOWLEDGE THAT YOU HAVE READ, UNDERSTOOD, AND AGREE TO BE
        BOUND BY THESE TERMS.
      </p>

      <p>
        IF YOU ARE A CALIFORNIA RESIDENT PLEASE READ THE FOLLOWING IMPORTANT
        NOTICE
      </p>

      <p>
        Under the California Consumer Privacy Act of 2018 (CCPA) California
        residents shall have the right to request:
      </p>

      <ul>
        <li>the categories of personal information that is processed;</li>
        <li>
          the categories of sources from which personal information is obtained;
        </li>
        <li>the purpose for processing of user personal data;</li>
        <li>
          the categories of third parties with whom we may share your personal
          information;
        </li>
        <li>
          the specific pieces of personal information that we might have
          obtained about particular user provided that the data given in the
          request is reliable enough and allows to identify the user.
        </li>
      </ul>

      <p>Please use the navigation links through this Privacy Policy:</p>

      <h3>PERSONAL INFORMATION</h3>

      <p>
        All about the categories of information, its sources and purposes of
        processing.
      </p>

      <p>
        Please mind that according to CCPA personal information does not include
        de-identified or aggregated consumer information.
      </p>

      <h3>SHARING</h3>

      <p>How your information can be shared.</p>

      <p>
        Please note that all third parties that are engaged in processing user
        data are service providers that use such information on the basis of
        agreement and pursuant to business purpose.
      </p>

      <h3>OPT-OUT OPTIONS</h3>

      <p>
        If you don’t want us to process your personal information any more
        please contact us through the Support email
        <a href="mailto:info@lily-plant.com" class="link">info@lily-plant.com</a
        >. In most cases there is no way to maintain the App’s further operating
        without functional data therefore you will be advised to remove the App
        from your device.
      </p>

      <p>
        If you don’t want us to share device identifiers and geolocation data
        with service providers please check your device settings to opt out as
        described below
      </p>

      <h3>REQUESTS</h3>

      <p>
        To submit a verifiable consumer request for access, portability or
        deletion personal data please contact us through the Support email
        <a href="mailto:info@lily-plant.com" class="link">info@lily-plant.com</a
        >. Please include in the text of your appeal the wording "Your rights to
        maintain confidentiality in the state of California”.
      </p>

      <p>When submitting a verifiable request, you should be ready to:</p>

      <p>
        Provide sufficient information that allows us to reasonably verify you
        are the person about whom we collected personal information or an
        authorized representative, which may include: name, address, city,
        state, and zip code and email address. We may use this information to
        surface a series of security questions to you to verify your identity.
        If you are making a request through an authorized agent acting on your
        behalf, such authorized agent must provide written authorization
        confirming or a power of attorney, signed by you.
      </p>

      <p>
        Describe your request with sufficient detail that allows us to properly
        understand, evaluate, and respond to it.
      </p>

      <p>
        We will not be able to respond to your request or provide you with
        personal information if we cannot: (i) verify your identity or authority
        to make the request; or (ii) confirm the personal information relates to
        you. We may ask you for additional information or documents to verify
        your identity. We may also carry out checks, including with third party
        identity verification services, to verify your identity before taking
        any action with your personal information. This is regarded as a
        safeguard measure to prevent disclosure of your personal information
        under a fake or scum request.
      </p>

      <p>
        We ensure that personal information provided in a verifiable consumer
        request will be used only to verify the requestor’s identity or
        authority to make the request and not for any other purpose. We will
        keep it for the adequate term reasonably needed for the purpose
        described above and delete after the purpose is fulfilled.
      </p>

      <p>
        We try to respond to a verifiable consumer request within forty-five
        (45) days of its receipt. If we require more time, we will inform you of
        the reason and extension period in writing. Please note that we are only
        required to respond to two requests per customer each year.
      </p>

      <h3>EQUAL RIGHTS</h3>

      <p>
        Nothing in the way we deal with your request shall be interpreted as
        discrimination, which means that we will not set up different pricing or
        products, or different level or quality of services for you, if you
        choose to exercise your rights. However, in some circumstances, we may
        not be able to provide services if you choose to delete your personal
        information from our records.
      </p>

      <h3>SALE OF DATA</h3>

      <p>We do not sell any of your personal data to third parties.</p>
    </section>

    <section>
      <h2>II. INFORMATION WE PROCESS</h2>

      <p>There are several categories of information that can be processed.</p>

      <p><strong>Information that you submit</strong></p>

      <p>
        We process the following personal information about you when you use the
        App. This information is necessary for the adequate performance of the
        contract between you and us. Without such information it is impossible
        to provide complete functionality of the App and perform the requested
        services.
      </p>

      <p>
        Contact Information (name, e-mail address, as well as any other content
        included in the email) which you may fill in by yourself when you
        contact us via email
        <a href="mailto:info@lily-plant.com" class="link">info@lily-plant.com</a
        >. We use such information to respond effectively to your inquiry,
        fulfill your requests, and send you communications that you request.
      </p>

      <p><strong>Information That Is Processed Automatically</strong></p>

      <p>
        When you use the Service, some information about your device and your
        user behaviour may be processed automatically. This information is
        generally non-personal, i.e. it does not, on its own, permit direct
        association with any specific individual, and we may access it only in
        aggregated form. We process this information on the ground of our
        legitimate interest in improving our App and giving our users the best
        experience. If we do not access such data we may not be able to provide
        you with all the features of the Service.
      </p>

      <p>
        We use third-party automatic data processing technologies to analyze
        certain information sent by your device via our Service (analytics
        tools). Some of them launch automated processing of your personal data,
        including profiling, which means any form of automated processing of
        personal data used to evaluate certain personal aspects relating to you,
        in particular to analyze or predict aspects concerning your personal
        preferences, interests, behavior, location or movements (see the list of
        data described below). Processing information through automatic data
        processing technologies starts automatically when you first time launch
        the Service.
      </p>

      <p>
        <strong>Device Details.</strong> When you use a mobile device (tablet /
        phone / smartwatch) to access our App, some of details about your device
        are reported, including “device identifiers”. Device identifiers are
        small data files or similar data structures stored on or associated with
        your mobile device, which uniquely identify your mobile device (but not
        your personality). Device identifier enables generalized reporting or
        personalized content and ads by the third parties.What data can be
        processed:
      </p>

      <ul>
        <li>
          Information about the device itself: type of your device, type of
          operating system and its version, model and manufacturer, screen size,
          screen density, orientation, audio volume and battery, device memory
          usage.
        </li>
        <li>
          Information about the internet connection: mobile carrier, network
          provider, network type, IP address, timestamp and duration of
          sessions, speed, browser.
        </li>
        <li>
          Location-related information: IP address, the country code/ region/
          state/ city associated with your SIM card or your device, language
          setting, time zone, neighboring commercial points of interest (eg.
          “coffee shop”).
        </li>
        <li>
          Device identifiers: Identity For Advertisers for iOs devices/
          Advertising ID, user identifiers (if they are set up by the Service’s
          developer).
        </li>
      </ul>

      <p>
        <strong>Information about the applications.</strong> Name, API key
        (identifier for application), version, properties of our App can be
        reported for automated processing and analyzes. Some services also
        record the list of applications and/or processes which are installed or
        run on your device.
      </p>

      <p>
        <strong>Cookies and similar technologies.</strong> When you use the App,
        cookies and similar technologies may be used (pixels, web beacons,
        scripts). A cookie is a text file containing small amounts of
        information which is downloaded to your device when you access the App.
        The text file is then sent back to the server each time you use the App.
        This enables us to operate the App more effectively. For example, we
        will know how many users access a specific areas or features within our
        App and which links or ads they clicked on. We use this aggregated
        information to understand and optimize how our App is used, improve our
        marketing efforts, and provide content and features that are of interest
        to you.
      </p>

      <p>
        <strong>Log file information.</strong> Log file information is
        automatically reported each time you make a request to access the App.
        It can also be provided when the App is installed on your device. When
        you use our App, analytics tools automatically record certain log file
        information, including time and date when you start and stop using the
        App, and how you interact with the App.
      </p>

      <p>
        <strong>In-app events.</strong> When you use our App, analytics tools
        automatically record your activity information (tutorial steps,
        levelling up, payments, in-app purchases, custom events, progression
        events, method of limiting the processing of user data).
      </p>

      <p>
        Information provided automatically to analytics tools does not generally
        come to our control, therefore we cannot be responsible for processing
        such information. Please mind that some services are engaged in personal
        data profiling and may obtain information related to your personality
        and/or your device by using technologies that do not belong to our scope
        of responsibility. In case when your user ID is linked to your Facebook
        account, Facebook may use your device information in association with
        categorized data that were already recorded in its databases (eg. your
        age, gender or other demographic indication). We do not control,
        supervise or stand surety for how the third parties process your
        personal data, that might be collected by their own means (not through
        our App). Any information request regarding the disclosure of your
        personal information should be directed to such third parties (see
        Section IV).
      </p>

      <p><strong>Payment Information</strong></p>

      <p>
        We provide paid products and/or services within the Service. For this
        purpose, we use third-party services for payment processing (for
        example, payment processors). As a result of this processing, you will
        be able to make a payment and we will be notified that the payment has
        been made.
      </p>

      <p>
        We will not store or collect your payment card details ourselves. This
        information will be provided directly to our third-party payment
        processors.
      </p>
    </section>

    <section>
      <h2>III. THE PURPOSES OF PROCESSING YOUR PERSONAL DATA</h2>

      <p>
        Our mission is to constantly improve our App and provide you with new
        experiences. As part of this mission, we use your information for the
        following purposes:
      </p>

      <ul>
        <li>
          To make our service available. We use the information that you submit
          and information that is processed automatically to provide you with
          all requested services.
        </li>
        <li>
          To improve, test and monitor the effectiveness of our Service. We use
          the information that is processed automatically to better understand
          user behavior and trends, detect potential outages and technical
          issues, to operate, protect, improve, and optimize our Service.
        </li>
        <li>
          To communicate with you. We use the information we have to communicate
          with you through newsletters, i.e. to send you marketing
          notifications, receive your feedback about our App experience, and let
          you know about our policies and terms. We also use your information to
          respond to you when you contact us.
        </li>
        <li>
          To prevent fraud and spam, to enforce the law. We really want our App
          to be free of spam and fraudulent content so that you feel safe and
          free. We may use your information to prevent, detect, and investigate
          fraud, security breaches, potentially prohibited or illegal
          activities, protect our trademarks and enforce our Terms of Use.
        </li>
      </ul>

      <p>
        If any new purposes for processing your personal data arise we will let
        you know we start to process information on that other purpose by
        introducing the corresponding changes to this Privacy policy.
      </p>
    </section>

    <section>
      <h2>IV. SHARING OF YOUR INFORMATION</h2>

      <p>
        We will share your information with third parties only in the ways that
        are described in this Privacy policy.
      </p>

      <p>
        Please note that while we partner solely with third parties that gave us
        assurance of application of necessary technical and organizational
        measures to protect your personal data, we cannot guarantee the security
        of any information transmitted from the App directly to such third
        party. We are not responsible for any accidental loss or unauthorized
        access to your personal data through a fault of third parties.
      </p>

      <p>
        We will not rent or sell your personal data to any third parties, but we
        may share your information from tools like cookies, log files, and
        device identifiers and location data, with third-party organizations
        that provide automatic data processing technologies for the App. We do
        not control or influence these third parties’ tracking technologies or
        how they may be used.
      </p>

      <p>
        We may disclose your personal information if it is needed for objective
        reasons, due to the public interest or in other unforeseen
        circumstances:
      </p>

      <ul>
        <li>as required by law;</li>
        <li>
          when we believe, in good faith, that disclosure is necessary to
          protect our rights, protect your safety or the safety of others,
          investigate fraud, or respond to a government request;
        </li>
        <li>
          if we are involved in a merger, acquisition, or sale of all or a
          portion of our assets, you will be notified via email and/or a
          prominent notice in our App of any change in ownership or your
          personal information usage, as well as any choices you may have
          regarding your personal information.
        </li>
      </ul>
    </section>

    <section>
      <h2>V. INTERNATIONAL DATA TRANSFERS</h2>

      <p>
        We work in the cross-border area and provide our App to our Users around
        the world.
      </p>

      <p>
        We and third-party organizations that provide automatic data processing
        technologies for the App may transfer the automatically processed
        information across borders and from your country or jurisdiction to
        other countries or jurisdictions around the world.
      </p>

      <p>
        If you are located in the European Union or other regions with laws
        governing data processing that may differ from U.S. law, please note
        that we may transfer information, including personal information, to a
        country and jurisdiction that does not have the same data protection
        laws as in your jurisdiction.
      </p>

      <p>
        This means that your personal information can be transferred to a third
        country, a territory or one or more specified sectors within that third
        country, or to the international organization where data protection and
        confidentiality regulations may not provide the same level of protection
        of personal data as your country does.
      </p>

      <p>
        We try to make sure that the recipient of any personal data provides a
        proper protection of the personal data received, in accordance with the
        current legislation on the protection of such information. By using the
        App, you agree that we may transfer your personal data to any third
        country, a territory or one or more specified sectors within that third
        country, or to the international organization.
      </p>

      <p>
        For the purposes of data storage, we recourse to the services of the
        hosting organizations. We take your privacy seriously and, therefore,
        encrypt your personal data - if possible - before sending it to the
        hosting organizations for the purposes of its storage. Please note that
        we cooperate only with those hosting organizations that have passed our
        security and reliability check.
      </p>
    </section>

    <section>
      <h2>VI. HOW LONG WE USE YOUR PERSONAL DATA</h2>

      <p>
        We generally retain your personal information for as long as is
        necessary for performing the functional service of the App and to comply
        with our legal obligations. If you no longer want us to use your
        information that we physically access and store, you can request that we
        erase your personal information and close your account.
      </p>

      <p>
        However, some data may still be stored for a certain time period (but no
        longer than the storage purpose requires) if information is necessary to
        comply with legal obligation (taxation, accounting, audit) or in order
        to maintain safety and data backup settings, prevent fraud or other
        malicious acts.
      </p>
    </section>

    <section>
      <h2>VII. EXERCISING YOUR RIGHTS</h2>

      <p>
        Applicable data protection laws give you certain rights regarding your
        personal information. You have the following options in relation to your
        personal information that was collected:
      </p>

      <ul>
        <li>
          <strong>Data Access and Portability.</strong> You can request copies
          of your personal information.
        </li>
        <li>
          <strong>Change or Correct Data.</strong> Where you cannot update data
          by yourself through your account, you have the right to ask to correct
          change, update or rectify your data.
        </li>
        <li>
          <strong>Data Retention and Deletion.</strong> The user data is
          generally retained for as long as your user profile is in existence or
          as it is needed to provide the relevant services. However, specific
          retention times can vary based on context of the processing performed.
          You have the right to ask to delete all or some of the personal data
          that is held about you.
        </li>
        <li>
          <strong>Restriction of Processing.</strong> Under certain
          circumstances, you may have the right to limit the ways in which your
          personal information is used.
        </li>
      </ul>

      <p>
        To exercise any of the rights described above, you can contact us
        through Support email
        <a href="mailto:info@lily-plant.com" class="link"
          >info@lily-plant.com</a
        >
        Please bear in mind that we ensure the above mentioned rights only with
        respect to the information that we physically access and store.
      </p>

      <p>
        When your personal information is processed automatically you may object
        to such processing in some circumstances. Where your personal
        information is processed for direct marketing purposes, you may ask to
        cease processing your data for these direct marketing purposes.
      </p>
    </section>

    <section>
      <h2>VIII. Cookies and Pixels Notice</h2>

      <h3>A: Cookies</h3>

      <p>
        A 'cookie' is a small text file containing small amounts of information
        which is downloaded to your device when you visit a website or use
        applications. The cookie enables the server to collect information from
        the browser. We may use the following types of cookies:
      </p>

      <ul>
        <li>
          ESSENTIAL COOKIES: Cookies that are essential to the running of a
          Website. Without the use of cookies, parts of the Website would not
          function correctly. For example, when logging in to your account a
          session is created to allow you to browse the site and play games;
        </li>
        <li>
          ANALYTICAL COOKIES: We use analytical cookies to monitor our Website
          performance and to determine how visitors use the site. These cookies
          provide us with information that helps us create better products for
          our users and to identify areas that may need maintenance. We
          currently use Google Analytics, a popular web analytics service
          provided by Google, Inc. Google Analytics uses cookies to help us to
          analyse how players use our Website. We also use analytical cookies
          from additional third-party providers;
        </li>
        <li>
          PERSISTENT COOKIES: These are saved on your computer for a fixed
          period and are not deleted when the browser is closed. Such cookies
          are used where we need to know who you are for repeat visits, so the
          correct language is presented and to improve our users’ experience of
          the Website as well as present different marketing messages and
          advertisements for existing users;
        </li>
        <li>
          FUNCTIONAL COOKIES: Functional cookies are used to remember your
          preferences on our Website, enhancing the user experience. This can
          have a range of functions such as remembering your username or
          recording that you have read a site message so you don’t need to view
          it again;
        </li>
        <li>
          SESSION COOKIES: Session cookies are used by the server to store
          information about user page activities so users can easily pick up
          where they left off on the server's pages.
        </li>
      </ul>

      <p>
        We use a number of different cookies on this Website to help us to
        recognise you, track your activity and improve your use and experience
        of the Website. In addition, we use a number of third party service
        providers, who also set cookies on this Website, in order to deliver the
        services that they are providing to us. Such services include, but are
        not limited to, helping us to improve your use and experience of the
        Website by tracking your activity on the Website, measuring the
        effectiveness of the Website and the effectiveness of our marketing
        campaigns.
      </p>

      <p>
        We and/or third parties may use cookies to collect or receive
        information from the Website and use that information to advertise to
        you on other websites. You can view the cookies used for such purposes
        on this Website and opt out of the collection and use of your
        information for such targeted advertising here:
        www.aboutads.info/choices
      </p>

      <p>
        Some people find the idea of a website storing information on their
        computer or mobile (or other) device intrusive, particularly when this
        information is stored and used by a third party without them knowing.
        Although this is generally quite harmless, you may not, for example,
        want to see advertising that has been targeted to your interests. If you
        prefer, it is possible to block some or all cookies, or even to delete
        cookies that have already been set but you need to be aware that you
        might lose some functions of that website. Most online browsers
        automatically accept cookies. However, if you wish to restrict or block
        cookies you can modify your browser settings.
      </p>

      <h3>B: Pixels</h3>

      <p>
        We also use pixel-based tracking to track a visit or event on the
        platform and to track advertisements' impressions. This information is
        also used by us for remarketing purposes and for tracking conversions
        that are used to optimize our marketing activities. We may share such
        information (which is non-personal information) with our advertising and
        marketing partners. Please see specific information about our marketing
        practices in section 8. By accessing and using the Website and services,
        you consent to the placement of cookies and pixels on your device in
        accordance with this Notice.
      </p>
    </section>

    <section>
      <h2>IX. SECURITY</h2>

      <p>
        The security of your personal information is highly important to us. We
        follow generally accepted industry standards to protect the personal
        information submitted to us, both during transmission and once we
        receive it.
      </p>

      <p>
        We take reasonable and appropriate measures to protect personal
        information from loss, misuse and unauthorized access, disclosure,
        alteration and destruction, taking into account the risks involved in
        the processing and the nature of the personal information.
      </p>

      <p>
        We implement appropriate technical and organizational measures, which
        are designed to implement data-protection principles, such as data
        minimization, in an effective manner and to integrate the necessary
        safeguards into the processing. We seek your personal data to be
        encrypted with proper and strong encryption algorithms, including
        hashing where possible.
      </p>

      <p>
        Unfortunately, no method of transmission over the Internet, or method of
        electronic storage, is 100% secure. We do our best to protect your
        personal data, nevertheless, we cannot guarantee its absolute security.
        In the event that your personal information is compromised as a breach
        of security, we will promptly notify you in compliance with applicable
        law.
      </p>

      <p>
        If you have any questions about the security of our App, you can contact
        us through Support email
        <a href="mailto:info@lily-plant.com" class="link"
          >info@lily-plant.com</a
        >
      </p>
    </section>

    <section>
      <h2>XI. CHANGES TO THE PRIVACY POLICY</h2>

      <p>This Privacy policy is updated regularly.</p>

      <p>
        Whenever we change this Privacy policy, we will post those changes to
        this Privacy policy and other places that we consider appropriate.
        Additional forms of notice of modifications or updates as appropriate
        under the circumstances may be provided to you.
      </p>
    </section>

    <section>
      <h2>XII. HOW TO CONTACT US</h2>

      <p>
        If you have any questions about this Privacy Policy, please feel free to
        contact us at Support email
        <a href="mailto:info@lily-plant.com" class="link"
          >info@lily-plant.com</a
        >
      </p>
    </section>
  </article>
</template>
